import React from 'react'

import { SmallText } from '../presentation/Text'
import Center from '../helpers/Center'
import FlexGrid from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from './Link'
import { COLORS } from '@btime/constants'
import Tooltip from '../../packages/kiti/components/presentation/Tooltip'

const HoverIconText = ({ label, emptyLabel, icon, onClick, multiple = false, ...props }) => {
  const items = label?.split(',') || []

  return (
    <FlexGrid justify="flex-start" gutter={0.2}>
      {!!label && !multiple && <SmallText color={COLORS.dark3}>{label}</SmallText>}
      {!!label && multiple && (
        <Tooltip label={<SmallText color={COLORS.dark3}>{items.join(', ')}</SmallText>} bgColor={COLORS.white}>
          <SmallText color={COLORS.dark3}>
            {items.slice(0, 2).join(', ')} ... ({items.length})
          </SmallText>
        </Tooltip>
      )}

      {!label && (
        <Link block onClick={onClick}>
          <SmallText color={COLORS.purple}>{emptyLabel}</SmallText>
        </Link>
      )}
      {onClick && (
        <Link block onClick={onClick}>
          <Center>
            <Icon name={icon || 'BsPencil'} size="0.8rem" color={!!label && COLORS.dark3} />
          </Center>
        </Link>
      )}
    </FlexGrid>
  )
}

export default HoverIconText
